module.exports = __webpack_public_path__ + "static/BT-mobile-13-6cc2d6cfc5eaf876b7a7cc7ac3c20d44.jpg";